import { locales } from './locales/pl';

export const environment = {
  production: false,
  locales
};
